import * as siteGlobals from './imports/helper/globals.js';

import { addJsToHtml } from './imports/addJsToHtml.js';
import { annualSalesMeter } from './imports/annualSalesMeter.js';

addJsToHtml();
annualSalesMeter();